import classNames from 'classnames'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import TaxLoader from './TaxLoader'

const TaxListItem = ({ currentTax, isCalculated, taxLabel }) => {
  const isCalculating = useSelector(state => state.taxes.isCalculating)
  const taxClass = classNames(
    'tax',
    'u-float--right',
    { 'font-5': !isCalculated }
  )

  return (
    <li>
      {taxLabel}{':'}
      <span className={taxClass}>
        <Choose>
          <When condition={isCalculating}>
            <TaxLoader />
          </When>
          <Otherwise>
            {currentTax}
          </Otherwise>
        </Choose>
      </span>
    </li>
  )
}

TaxListItem.propTypes = {
  currentTax: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isCalculated: PropTypes.bool.isRequired,
  taxLabel: PropTypes.string
}

export default TaxListItem
